const globalConfig = {
  TOKEN: "TOKEN",
  USER_ROLE: "USER_ROLE",
  ADMIN_GROWER_ID: "ADMIN_GROWER_ID",
  ADMIN_SCOUTING_ID: "ADMIN_SCOUTING_ID",
  ADMIN_SEASON_ID: "ADMIN_SEASON_ID",
};

export default globalConfig;
